// import React,{Component} from "react";
// import {
//   Col,
//   Progress,
//   FormGroup,
//   Label,
//   Input,
//   Button
// } from "reactstrap";
// import {base,s3base} from "api.js";
// import Sound from 'react-sound';
// import "components/custom.css";
// import {store,persistor} from 'store/index';
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
// import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

// class Summer extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       question:"",
//       secondCount:10,
//       secondCount1:600,
//       recordCount:0,
//       recordId:1,
//       intervalId:0,
//       intervalId1:0,
//       questionId:"",
//       reset:false,
//       lang:store.getState().user.lang,
//       soundStatus:true,
//       content:'',
//       soundPer:0,
//       volume:100,
//       correctFlag:true,
//       resultObj:{},
//       timeoutStat:false,
//       newQue: false,
//       playbackSpeed: 1,
//       soundKey: 0,
//       showTimer: false,
//       question_audio: null,
//       defaultSelectedVoice: null
//     };
//   }
//   componentDidMount() {
    
//     if (!this.props.answer) {
//       // select audio.
//       let question_audio = null;
//       let defaultSelectedVoice = null;
//       if ('question_audios' in this.props.data && this.props.data.question_audios.length > 0) {
//         let x = parseInt(Math.random() * 6);

//         const { question_audios } = this.props.data;
//         question_audio = `${s3base}/${question_audios[x].value}`;
//         defaultSelectedVoice = question_audios[x].label;
//       } else {
//         const { media_link } = this.props.data;
//         question_audio = `${s3base}${media_link}`;
//       }

//       this.setState({
//         question_audio,
//         defaultSelectedVoice
//       });
//     }

//     const { isQuestionTime, questionTime } = this.props;
//     if (isQuestionTime) {
//       this.setState({
//         secondCount1: questionTime * 60,
//         showTimer: isQuestionTime,
//       });
//     }
//     var intervalId = setInterval(this.timer, 1000);
//     var intervalId1 = setInterval(this.timer1, 1000);
//     this.setState({
//       intervalId,
//       intervalId1
//     });
//     // this.setState({intervalId1: intervalId1});
//   }

//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({secondCount:0});
//   };

//   stopTest = () =>{
//     this.props.nextQuestion({...this.state.resultObj,time:this.state.secondCount1});
//   }

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//         clearInterval(state.intervalId);
//   			clearInterval(state.intervalId1);
//   			clearInterval(state.recordId);

//         let question_audio = null;
//         let defaultSelectedVoice = null;
//         if ('question_audios' in props.data && props.data.question_audios.length > 0) {
//           let x = parseInt(Math.random() * 6);

//           const { question_audios } = props.data;
//           question_audio = `${s3base}/${question_audios[x].value}`;
//           defaultSelectedVoice = question_audios[x].label;
//         } else {
//           const { media_link } = props.data;
//           question_audio = `${s3base}${media_link}`;
//         }

//         const { isQuestionTime, questionTime } = props;
//         let secondState = { secondCount1: 600, showTimer: false };
//         if (isQuestionTime) {
//           secondState = {
//             secondCount1: questionTime * 60,
//             showTimer: isQuestionTime,
//           };
//         }

//   			return {
//           newQue: true,
//           timeoutStat: false,
//           correctFlag: true,
//           recordCount: 0,
//           soundPer: 0,
//           content: '',
//           isRecording: false,
//           secondCount: 10,
//           ...secondState,
//           questionId: props.data.id,
//           blobURL: '',
//           reset: true,
//           soundStatus: true,
//           question_audio,
//           defaultSelectedVoice
//         };
//   		}else{
//   			if (!state.questionId) {
//   				return {content:'',correctFlag:true,questionId: props.data.id};
//   			}
//   		}
//   		}
//   }

//   copyToClipboard = () => {
//     document.execCommand("copy");
//   };

//   cutToClipboard = () => {
//     document.execCommand("cut");
//   };

//   pasteToClipboard = async () => {
//     alert("Press Ctrl+v for paste text");

//   };

// 	timer = () => {
//     if (this.state.secondCount === 1) {
//       clearInterval(this.state.intervalId);

//     }
//     this.setState({ secondCount: this.state.secondCount -1 });
//   }

//   timer1 = () => {
// 		if (this.state.secondCount1 === 1) {
// 			clearInterval(this.state.intervalId1);
//       this.setState({timeoutStat:true});
//       if (this.state.showTimer) {
//         this.props.nextQuestionHandler();
//       }
// 		}
//     //this.props.submit(this.state.resultObj,true);
// 		this.setState({ secondCount1: this.state.secondCount1 -1 });
// 	}

//   handleSongFinishedPlaying = () => {
//     this.setState({'soundStatus':false,});
//     this.props.soundChecked();
//     this.props.showResult();
//   }

// 	timerRecord = () => {
// 		if (this.state.recordCount === 40) {
// 			clearInterval(this.state.recordId);
// 			this.setState({timeoutStat:true});
// 		}
// 		this.setState({ recordCount: this.state.recordCount + 1 });
// 	}

// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//   chaneLang = (e) => {
//     this.setState({lang:e.target.value});
//   }

//   handleSongPlaying = (obj) => {
//     this.setState({soundPer:obj.position*100/obj.duration});
//   }

//   changeRange = (e) => {
//       this.setState({volume: e.target.value});
//   }

//   stopAudio = () => {
//     //var intervalId = setInterval(this.timer1, 1000);
//     this.setState({'soundStatus':false})
//   }

//   chaneText = (e) =>{
//     let { name, value } = e.target;

//     this.props.submit({'answer':value,'correct':'','length':value.split(' ').filter(function(n) { return n != '' }).length,time:this.state.secondCount1,lang:this.state.lang},true);
//     this.setState({ [name] : value,resultObj: {'answer':value,'correct':'','length':value.split(' ').filter(function(n) { return n != '' }).length,time:this.state.secondCount1,lang:this.state.lang} });
//   };

//   updateCorrect = () =>{
//     this.props.submit({'answer':'','correct':'','length':this.state.content.split(' ').filter(function(n) { return n != '' }).length,time:this.state.secondCount1,lang:this.state.lang});
//     this.setState({correctFlag:false,resultObj:{'answer':'','correct':'','length':this.state.content.split(' ').filter(function(n) { return n != '' }).length,time:this.state.secondCount1,lang:this.state.lang}})
//   }

//   newQuesFunc = () =>{
//     var intervalId1 = setInterval(this.timer1, 1000);
//     this.setState({intervalId1:intervalId1,newQue:false});
//   }

//   changePlaybackSpeed = (speed) => {
//     this.setState((prevState) => ({
//       soundKey: prevState.soundKey + 1
//     }));
//     this.setState({playbackSpeed: speed});
//   }

//   changeAudio = (selected) => {
//     clearInterval(this.state.intervalId1);
    
//     this.setState({
//       intervalId1: 0
//     }, () => {
      
//       const { question_audios } = this.props.data;
//       const selected_audio = question_audios.filter((audio, i) => {
//         return audio.label === selected.label;
//       });

//       this.setState({
//         question_audio: `${s3base}/${selected_audio[0].value}`
//       });
//     });
//   }

//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//     if(this.state.newQue){
//       this.newQuesFunc();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false});
//   	}
//     return (
//       <>
//      { !this.props.resultMode && <Col xs={12}>
//       	<Col xs={12} className="text-right"><b><p><i className="fa fa-clock-o"></i> <span>Time Left: {Math.floor(this.state.secondCount1 / 60) +':'+ (this.state.secondCount1 % 60)}</span></p> </b></Col>
//         <div className="col-lg-12 text-center">
//     		  <div className="currentStatus">
//             <div>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
//               {this.state.secondCount == 0 && this.state.soundStatus && ' Playing' }
//               <br></br>
//                 Volume
//                <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//                <br></br>
//               <Progress color="info" value={(this.state.soundPer)} />
//               <div className="d-flex justify-content-between">
//                 <div className='stop-btn'>
//                   {!this.props.testMode && this.state.secondCount!==0 && this.state.blobURL === '' && !this.state.isRecording && <Button color="success" onClick={this.skip} size="sm">Skip</Button> }
//                   {!this.props.testMode && this.state.soundStatus ===true && this.state.secondCount ==0  && <Button color="success" onClick={this.stopAudio} size="sm">Skip</Button>}
//                 </div>
//                 {!this.props.testMode && (
//                   <div className="stop-btn clearfix">
//                     <div className="select-voice pull-left">
//                       {this.state.defaultSelectedVoice !== null &&
//                         <SelectVoiceDropDown
//                           voices={this.props.voices}
//                           selected={this.state.defaultSelectedVoice}
//                           changeAudio={this.changeAudio}
//                         />
//                       }
//                     </div>
//                     <div className="select-speed pull-right">
//                       <PlaybackSpeedBtns changePlaybackSpeed={this.changePlaybackSpeed} playbackSpeed={this.state.playbackSpeed} />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         <Col xs={12}>
//           {this.props.data && !this.props.resultMode && this.state.soundStatus && this.state.secondCount === 0 &&
//             <Sound
//               url={this.state.question_audio}
//               playStatus={Sound.status.PLAYING}
//               onFinishedPlaying={this.handleSongFinishedPlaying}
//               onPlaying={this.handleSongPlaying}
//               volume={this.state.volume}
//               playbackRate={this.state.playbackSpeed}
//               key={this.state.soundKey}    
//             />
//           }
//         </Col>
// 		  <Col xs={12}>
// 		  	{ this.state.blobURL && <audio src={this.state.blobURL} controls="controls" />}
// 		  </Col>
// 		</div>
//       </Col> }

//       <Col xs={12}><h5>{question}</h5></Col>
//       {!this.props.resultMode && !this.props.answer && <>
//         <Col xs={2} style={{margin:'10px'}}>

//         </Col>
//         <Col xs={12}>
//               <FormGroup>
//                 {!this.state.timeoutStat && <Input type="textarea" autoCorrect="false" spellCheck="false" name="content" id="textBox" onChange={(e) => { this.chaneText(e)} } value={this.state.content} />}
//                 {this.state.timeoutStat && <div className="timeout-box">{this.state.content}</div>}
//               </FormGroup>
//               <div className="bottomContent">
//                 <div className="copyPaste">
//                   <a href="javascript:void(0)" onClick={this.cutToClipboard} className="btn">Cut</a>
//                   <a href="javascript:void(0)" onClick={this.copyToClipboard} className="btn">Copy</a>
//                   <a href="javascript:void(0)" onClick={this.pasteToClipboard} className="btn">Paste</a>
//                 </div>
//                 <p className="wordCount">Total word count: {this.state.content.split(' ').filter(function(n) { return n != '' }).length}</p>
//               </div>
//             </Col>
//             <Col xs={12}>
//               <h4 className="infoText">

//                 <p></p>
//                 <p></p>
//               </h4>
//             </Col></>
//           }
//       </>
//     );
//   }
// }

// export default Summer;

import React, { useState, useEffect, useRef } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import { base, s3base } from "api.js";
import Sound from 'react-sound';
import "components/custom.css";
import { store } from 'store/index';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import { formatTimeMiliSecond } from "util/helper.js";

const Summer = (props) => {
  // All state declarations
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [secondCount1, setSecondCount1] = useState(480);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId1, setIntervalId1] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [lang, setLang] = useState(store.getState().user.lang);
  const [soundStatus, setSoundStatus] = useState(true);
  const [content, setContent] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [newQue, setNewQue] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [remainingTime, setRemainingTime] = useState("00:00");
  // Refs for intervals
  const intervalIdRef = useRef(0);
  const intervalId1Ref = useRef(0);
  const recordIdRef = useRef(1);

  
  // Timer functions
  const timer = () => {
    setSecondCount((prevCount) => {
      if (prevCount <= 1) {
        clearInterval(intervalIdRef.current);
        return 0;
      }
      return prevCount - 1;
    });
  };

  const timer1 = () => {
    setSecondCount1((prevCount) => {
      if (prevCount === 1) {
        clearInterval(intervalId1Ref.current);
        setTimeoutStat(true);
        if (showTimer && props.nextQuestionHandler) {
          props.nextQuestionHandler();
        }
      }
      return prevCount - 1;
    });
  };

  const timerRecord = () => {
    setRecordCount((prevCount) => {
      if (prevCount === 40) {
        clearInterval(recordIdRef.current);
        setTimeoutStat(true);
      }
      return prevCount + 1;
    });
  };

  // Initial mount effect
  useEffect(() => {
    if (!props.answer && props.data) {
      let question_audio = null;
      let defaultSelectedVoice = null;
      
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);
        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoice = question_audios[x].label;
      } else if (props.data.media_link) {
        question_audio = `${s3base}${props.data.media_link}`;
      }

      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoice);
    }

    const { isQuestionTime, questionTime } = props;
    if (isQuestionTime) {
      setSecondCount1(questionTime * 60);
      setShowTimer(isQuestionTime);
    }

    const intId = setInterval(timer, 1000);
    const intId1 = setInterval(timer1, 1000);
    intervalIdRef.current = intId;
    intervalId1Ref.current = intId1;
    setIntervalId(intId);
    setIntervalId1(intId1);

    return () => {
      clearInterval(intervalIdRef.current);
      clearInterval(intervalId1Ref.current);
      clearInterval(recordIdRef.current);
    };
  }, []);

  // Handle question changes
  useEffect(() => {
    if (!props.data) return;

    const shouldReset = (questionId && questionId !== props.data.id) || props.restart;
    
    if (shouldReset) {
      clearInterval(intervalIdRef.current);
      clearInterval(intervalId1Ref.current);
      clearInterval(recordIdRef.current);

      let question_audio = null;
      let defaultSelectedVoiceLocal = null;
      
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);
        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoiceLocal = question_audios[x].label;
      } else if (props.data.media_link) {
        question_audio = `${s3base}${props.data.media_link}`;
      }

      const { isQuestionTime, questionTime } = props;
      let secondCount1Val = 480;
      let showTimerVal = false;
      
      if (isQuestionTime) {
        secondCount1Val = questionTime * 60;
        showTimerVal = isQuestionTime;
      }

      setNewQue(true);
      setTimeoutStat(false);
      setCorrectFlag(true);
      setRecordCount(0);
      setSoundPer(0);
      setContent('');
      setIsRecording(false);
      setSecondCount(10);
      setSecondCount1(secondCount1Val);
      setShowTimer(showTimerVal);
      setQuestionId(props.data.id);
      setBlobURL('');
      setReset(true);
      setSoundStatus(true);
      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoiceLocal);
    } else if (!questionId && props.data.id) {
      setContent('');
      setCorrectFlag(true);
      setQuestionId(props.data.id);
    }
  }, [props.data?.id, props.restart]);

  // Handle reset timer
  useEffect(() => {
    if (reset) {
      const intId = setInterval(timer, 1000);
      intervalIdRef.current = intId;
      setIntervalId(intId);
      setReset(false);
    }
  }, [reset]);

  // Handle new question timer
  useEffect(() => {
    if (newQue) {
      const intId1 = setInterval(timer1, 1000);
      intervalId1Ref.current = intId1;
      setIntervalId1(intId1);
      setNewQue(false);
    }
  }, [newQue]);

  // Handle restart
  useEffect(() => {
    if (props.restart && props.restartQue) {
      props.restartQue();
    }
  }, [props.restart]);

  // Handle stop recording
  useEffect(() => {
    if (props.stopRecording && props.nextQuestion) {
      props.nextQuestion({ ...resultObj, time: secondCount1 });
    }
  }, [props.stopRecording]);

  // Handle correct flag update
  useEffect(() => {
    if (props.data && correctFlag && props.submit) {
      const newResultObj = {
        answer: '',
        correct: '',
        length: content.split(' ').filter(n => n !== '').length,
        time: secondCount1,
        lang: lang
      };
      props.submit(newResultObj);
      setCorrectFlag(false);
      setResultObj(newResultObj);
    }
  }, [props.data, correctFlag]);

  // Event handlers
  const skip = () => {
    clearInterval(intervalIdRef.current);
    setSecondCount(0);
  };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  const cutToClipboard = () => {
    document.execCommand("cut");
  };

  const pasteToClipboard = async () => {
    alert("Press Ctrl+v for paste text");
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    if (props.soundChecked) props.soundChecked();
    if (props.showResult) props.showResult();
  };

  const chaneLang = (e) => {
    setLang(e.target.value);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const stopAudio = () => {
    setSoundStatus(false);
  };

  const chaneText = (e) => {
    const { value } = e.target;
    const wordCount = value.split(' ').filter(n => n !== '').length;
    
    const newResultObj = {
      answer: value,
      correct: '',
      length: wordCount,
      time: secondCount1,
      lang: lang
    };

    if (props.submit) {
      props.submit(newResultObj, true);
    }
    setContent(value);
    setResultObj(newResultObj);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId1Ref.current);
    setIntervalId1(0);

    if (props.data && props.data.question_audios) {
      const selected_audio = props.data.question_audios.find(
        audio => audio.label === selected.label
      );
      if (selected_audio) {
        setQuestionAudio(`${s3base}/${selected_audio.value}`);
      }
    }
  };

  const questionText = props.data ? props.data.question : "";
  const wordCount = content.split(' ').filter(n => n !== '').length;
  const totalSeconds = Math.max(0, Math.floor(secondCount1));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return (
    <>
      {!props.resultMode && (
        <Col xs={12}>
          <Col xs={12} className="text-right">
            <b>
              <p>
                <i className="fa fa-clock-o"></i>{' '}
                <span>
                  

                  Time Left: {minutes}:{seconds.toString().padStart(2, "0")}
                  {/* Time Left: {Math.floor(secondCount1 / 60)}:{secondCount1 % 60} */}
                </span>
              </p>
            </b>
          </Col>
          <div className="col-lg-12 p-0 text-center">
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              <div className="w-100 text-white p-4">
                {/* Current Status:
                {soundStatus && secondCount !== 0 && !isRecording && 
                  ` Begining in ${secondCount} seconds`}
                {secondCount === 0 && soundStatus && ' Playing'} */}
                <div className="d-flex justify-content-end w-100 align-items-center" style={{minHeight:"20px"}}>
                  {(secondCount === 0 && blobURL === '' && !isRecording) &&
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  }
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3" >
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barStyle={{ backgroundColor: "#4493e0" }} now={(soundPer)} />
                  </div>
                </div>
                <div className="d-flex justify-content-start w-100 align-items-center" style={{ minHeight: "20px" }} >
                  {soundPer === 100 ? (
                    <p className="mb-0 fs-10 mx-4">Completed</p>
                  ) : soundStatus === true &&
                    secondCount !== 0 &&
                    !isRecording ? (
                    <p className="mb-0 fs-10 mx-4">
                      The clip will begin in {secondCount} seconds
                    </p>
                  ) : (
                    <p className="mb-0 fs-10 mx-4 invisible"></p>
                  )}
                </div>
                <br />
                <div className="w-100 d-flex justify-content-center align-items-center" >
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50" >
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" />
                  </div>
                </div>
                <br />
                <div className="d-flex justify-content-between">
                  <div className="stop-btn">
                    {!props.testMode && secondCount !== 0 && blobURL === '' && !isRecording && (
                      <Button variant="success" onClick={skip} size="sm">
                        Skip
                      </Button>
                    )}
                    {!props.testMode && soundStatus && secondCount === 0 && (
                      <Button variant="success" onClick={stopAudio} size="sm">
                        Skip
                      </Button>
                    )}
                  </div>
                  {!props.testMode && (
                    <div className="stop-btn clearfix">
                      <div className="select-voice pull-left">
                        {defaultSelectedVoice !== null && props.voices && (
                          <SelectVoiceDropDown
                            voices={props.voices}
                            selected={defaultSelectedVoice}
                            changeAudio={changeAudio}
                          />
                        )}
                      </div>
                      <div className="select-speed pull-right">
                        <PlaybackSpeedBtns
                          changePlaybackSpeed={changePlaybackSpeed}
                          playbackSpeed={playbackSpeed}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Col xs={12}>
              {props.data && !props.resultMode && soundStatus && secondCount === 0 && questionAudio && (
                <Sound
                  key={soundKey}
                  url={questionAudio}
                  playStatus={Sound.status.PLAYING}
                  onFinishedPlaying={handleSongFinishedPlaying}
                  onPlaying={handleSongPlaying}
                  volume={volume}
                  playbackRate={playbackSpeed}
                />
              )}
            </Col>
            <Col xs={12}>
              {blobURL && <audio src={blobURL} controls="controls" />}
            </Col>
          </div>
        </Col>
      )}

      <Col xs={12}>
        <h5>{questionText}</h5>
      </Col>
      
      {!props.resultMode && !props.answer && (
        <>
          <Col xs={2} style={{ margin: '10px' }}></Col>
          <Col xs={12}>
            <div className="bottomContent test-editor-blue">
              <div className="copyPaste d-flex gap-2 mx-1 py-1">
                <a href="javascript:void(0)" onClick={cutToClipboard} className="btn">Cut</a>
                <a href="javascript:void(0)" onClick={copyToClipboard} className="btn">Copy</a>
                <a href="javascript:void(0)" onClick={pasteToClipboard} className="btn">Paste</a>
              </div>
            </div>
           <Form.Group id="formGroupDiv">
              {!timeoutStat && (
                <Form.Control
                  as="textarea"
                  autoCorrect="false"
                  spellCheck="false"
                  name="content"
                  id="textBox"
                  onChange={chaneText}
                  value={content}
                />
              )}
              {timeoutStat && <div className="timeout-box">{content}</div>}
            </Form.Group>
            <div className="bottomContent test-editor-blue">
              <div className="copyPaste">
                <p className="wordCount text-white text-start p-2">Word Count: {wordCount}</p>
              </div>
            </div>
          </Col>
          {/* <Col xs={12}>
            <div className="bottomContent">
              <div className="copyPaste">
                <a href="javascript:void(0)" onClick={cutToClipboard} className="btn">
                  Cut
                </a>
                <a href="javascript:void(0)" onClick={copyToClipboard} className="btn">
                  Copy
                </a>
                <a href="javascript:void(0)" onClick={pasteToClipboard} className="btn">
                  Paste
                </a>
              </div>
              <p className="wordCount">Total word count: {wordCount}</p>
            </div>
          </Col> */}

          {/* <Col xs={12}>
            <h4 className="infoText">
              <p></p>
              <p></p>
            </h4>
          </Col> */}
        </>
      )}
    </>
  );
};

export default Summer;